/** @jsx h */

import { h } from 'preact'; // eslint-disable-line
import PropTypes from 'prop-types';
import styles from './index.scss';

const IconClose = ({ fill, className, width, height, onClick }) => (
    <svg
        className={`apc-svg-icon ${styles.iconClose} ${className}`}
        viewBox="0 0 20 2"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        onClick={onClick}
    >
        <rect x="0" y="0" width="20" height="2" stroke="none" fill={fill} />
    </svg>
);

IconClose.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    onClick: PropTypes.func,
};

IconClose.defaultProps = {
    fill: '#FFF',
    className: '',
    width: 20,
    height: 2,
    onClick: () => {},
};

export default IconClose;
